import { useMutation } from "@tanstack/react-query";
import { AxiosResponseAndError } from "../types/axiosResponseType";
import { ViewMode } from "@/components/views/custom/gantt/src";
import ApiRequest from "../ApiRequest";
import { requestURLs } from "@/Environment";

type RequestType = {
  viewMode: ViewMode;
  inPercentage: boolean;
  isWorkloadPlanning: boolean;
  dates: Date[];
};

type ResponseType = any;

export const useGetCapacityPlanningMutation = () => {
  return useMutation<
    AxiosResponseAndError<ResponseType>["response"], // success type
    AxiosResponseAndError<ResponseType>["error"],    // error type
    RequestType                                      // variables passed to mutate()
  >({
    mutationFn: (data: RequestType) =>
      ApiRequest.post<ResponseType>(requestURLs.capacityPlanning, data),
    retry: 0,
  });
};
